import { memo } from "react";

export const AppCssBaseLine = memo(() => {
	return null;
});
AppCssBaseLine.displayName = "AppCssBaseLine";
